import React from 'react'
import Home from '../Components/Headers/Home'

function HomePage() {
  return (
    <>
    <Home/>
    </>
  )
}

export default HomePage